
import moment from "moment";

const addTimeStamp = (url) => {
    if (typeof url === "string" && url.length > 0 && url.indexOf("?") === -1) {
        return url + "?" + moment().unix();
    }
    return url;
};

export const TransformUserData = (user, loggedInPhone) => {

    let parentProfile = {};
    const activeChildDetail = user.activeChildDetail;

    let childList = user.childList;
    let email =
        activeChildDetail.parent === "Mother"
            ? activeChildDetail?.mother_email
            : activeChildDetail?.father_email;
    let password = (loggedInPhone === activeChildDetail?.mother_phone) ? activeChildDetail?.mother_password : activeChildDetail?.father_password;
    let phone = loggedInPhone
        ? loggedInPhone
        : activeChildDetail.parent === "Mother"
            ? activeChildDetail.mother_phone
            : activeChildDetail.father_phone;
    // console.log("phone at transformdata", phone)
    try {
        // const activeChildDetail = action.payload.activeChildDetail;
        const parentName = activeChildDetail.parent_name;
        const fatherName = activeChildDetail.father_name;
        const motherName = activeChildDetail.mother_name;
        const fatherPhoto = activeChildDetail.father_photo;
        const motherPhoto = activeChildDetail.mother_photo;
        const parentType = activeChildDetail.parent;
        const motherEmail = activeChildDetail.mother_email.toLowerCase();
        const fatherEmail = activeChildDetail.father_email.toLowerCase();
        const motherPhone = activeChildDetail.mother_phone;
        const fatherPhone = activeChildDetail.father_phone;
        const motherPhotoApproved = activeChildDetail.mother_approved_status;
        const fatherPhotoApproved = activeChildDetail.father_approved_status;
        parentProfile = {
            parentName,
            parentType,
            motherEmail,
            fatherEmail,
            motherPhone,
            fatherName,
            motherName,
            fatherPhone,
            motherPhoto,
            fatherPhoto,
            // childPhoto,
            parentPhone:
                parentType.toLowerCase() === "mother" ? motherPhone : fatherPhone,
            parentPhoto: addTimeStamp(
                parentType.toLowerCase() === "mother"
                    ? motherPhoto
                    : fatherPhoto
            ),
            parentApprovedStatus:
                parentType.toLowerCase() === "mother"
                    ? motherPhotoApproved
                    : fatherPhotoApproved,
            motherPhotoApproved,
            fatherPhotoApproved,
            parentEmail: parentType.toLowerCase() === "mother" ? motherEmail : fatherEmail,
        };

        // updating the timestamp in child photo
        activeChildDetail.childPhoto = addTimeStamp(
            activeChildDetail.childPhoto
        );

        // updating the timestamp in other child photos

        childList = childList.map((child) => ({
            ...child,
            childPhoto: addTimeStamp(child.childPhoto),
        }));
    } catch (error) { }

    // Get session_id from activeChildDetail based on parent type
    const session_id = activeChildDetail.parent === "Mother"
        ? activeChildDetail?.mother_session_id
        : activeChildDetail?.father_session_id;

    return {
        user: {
            email: email,
            password: password,
            phone: phone,
            session_id: session_id,
            lastLoggedIn: moment(),
        }
        , parentProfile,
        childList,
        activeChildDetail
    }
}